module.exports = __webpack_public_path__ + "img/eye_brown.bce4876a.png";